import React, { useEffect, useState } from "react";
import { DropdownSelect } from "@vds/selects";
import {
  InputHeaderTitle,
  TriggerFrame,
  TriggerInsideFrame,
  PeopleCountIsFrame,
  OperatorAndNumberFrame,
  GreyText,
  ConditionContainer,
  SmallText,
  ForFrame,
} from "./stylesRoiModal";
import {
  CVAPP_SLIPANDFALL,
  CVAPP_DWELLTIME,
  eventTriggerTexts,
  CVAPP_VEHICLECOUNTOA,
  CVAPP_PPEUSAGE,
  CVAPP_OPENDOOR,
  CVAPP_OBJECTDETECTION,
  CVAPP_UNOBJECTDETECTION,
  CVAPP_PROXIMITY,
  CVAPP_CAMERAADJUSTMENT,
  CVAPP_OBJECTBLUR,
  CVAPP_CROWDDENSITY,
  CVAPP_PEOPLE_COUNT_OA,
  CVAPP_PERSON_DETECTION,
  CVAPP_VEHICLE_DETECTION,
  CVAPP_WATERLEAK_DETECTION,
} from "../../../constants/cvappConstants";
import NumberInput from "../../NumberInput";
import ColorSelector from "../../ColorSelector";
import { useMemo } from "react";
import { updateRuleValue } from "../../../../store/actions";
import { useDispatch } from "react-redux";
import { Checkbox } from "@vds/checkboxes";
import InputStepperField from "../../InputStepperField";
import { isCvAppFromInHouseVersion } from "../../../utility/cvAppUtils";

function Trigger(props) {
  const dispatch = useDispatch();
  const { EventTrigger } = props;
  const { onDataChange } = props;
  const triggerText = eventTriggerTexts[EventTrigger];
  const { data } = props;
  const { cvappid, cvAppList } = props;
  const [condition, setCondition] = useState("");
  const [value, setValue] = useState("");
  const [coolPeriodValue, setCoolPeriodValue] = useState(10);
  const [time, setTime] = useState("");
  const [enable, setEnable] = useState(false);
  const [showCoolDownCheckBox, setShowCoolDownCheckbox] = useState(false);
  const [isError, setIsError] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [addCoolDownPeriod, setAddCoolDownPeriod] = useState(true);
  useEffect(() => {
    if (
      EventTrigger === CVAPP_VEHICLE_DETECTION ||
      EventTrigger === CVAPP_PERSON_DETECTION ||
      EventTrigger === CVAPP_SLIPANDFALL ||
      EventTrigger === CVAPP_OBJECTBLUR ||
      EventTrigger === CVAPP_OPENDOOR ||
      EventTrigger === CVAPP_PPEUSAGE ||
      EventTrigger === CVAPP_CAMERAADJUSTMENT ||
      EventTrigger === CVAPP_OBJECTDETECTION ||
      EventTrigger === CVAPP_PROXIMITY ||
      EventTrigger === CVAPP_PERSON_DETECTION ||
      EventTrigger === CVAPP_VEHICLE_DETECTION ||
      EventTrigger === CVAPP_UNOBJECTDETECTION ||
      EventTrigger === CVAPP_WATERLEAK_DETECTION
    ) {
      setEnable(true);
      setShowCoolDownCheckbox(true);
    }
  }, []);

  useEffect(() => {
    onDataChange({
      condition,
      value: value,
      time,
      enable,
      validTime: EventTrigger === CVAPP_DWELLTIME ? true : false,
      showBanner: isError,
      checkBoxData,
      coolPeriodValue,
      addCoolDownPeriod,
    });
  }, [
    condition,
    value,
    enable,
    time,
    isError,
    checkBoxData,
    addCoolDownPeriod,
    coolPeriodValue,
  ]);

  const handleCheckbox = (item) => {
    setCheckBoxData((prevData) =>
      prevData.includes(item)
        ? prevData.filter((i) => i !== item)
        : [...prevData, item]
    );
  };

  const handleCoolDownCheckbox = () => {
    setAddCoolDownPeriod(!addCoolDownPeriod);
    if (!addCoolDownPeriod) {
      setCoolPeriodValue(10);
    }
  };
  return (
    <>
      <TriggerFrame>
        {props?.action === true ? (
          <InputHeaderTitle>Trigger</InputHeaderTitle>
        ) : (
          ""
        )}
        <GreyText>Condition</GreyText>
        <ConditionContainer>
          {triggerText && <SmallText>{triggerText}</SmallText>}
          <TriggerInsideFrame>
            {EventTrigger === CVAPP_DWELLTIME && (
              <PeopleCountIsFrame>
                <OperatorAndNumberFrame>
                  <DropdownSelect
                    label="Operator"
                    width="37.23%"
                    onChange={(e) => setCondition(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option>Greater than</option>
                    <option>Less than</option>
                  </DropdownSelect>
                  <NumberInput
                    type="number"
                    label="Number"
                    width="20%"
                    value={value}
                    onChange={(value) => setValue(value)}
                    error={isError}
                    isError={isError}
                    setIsError={setIsError}
                    min={1}
                    appName={CVAPP_DWELLTIME}
                  />
                  <DropdownSelect
                    label="Unit of time"
                    width="153px"
                    onChange={(e) => setTime(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option>seconds</option>
                    <option>minutes</option>
                    <option>hours</option>
                  </DropdownSelect>
                </OperatorAndNumberFrame>
                {!isCvAppFromInHouseVersion(cvAppList, cvappid) && <><Checkbox
                  name="default"
                  width="auto"
                  label="Enable cool down period "
                  disabled={false}
                  error={false}
                  onChange={handleCoolDownCheckbox}
                  selected={addCoolDownPeriod}
                ></Checkbox>
                {addCoolDownPeriod && (
                  <InputStepperField
                    label={"Cool down period (min.)"}
                    value={coolPeriodValue}
                    onChange={(value) => setCoolPeriodValue(value)}
                    minValue={1}
                    maxValue={43201} // 30 days in minutes
                    readOnly={false}
                  />
                )}</>}
              </PeopleCountIsFrame>
            )}
            {(EventTrigger === CVAPP_PEOPLE_COUNT_OA ||
              EventTrigger === CVAPP_VEHICLECOUNTOA ||
              EventTrigger === CVAPP_CROWDDENSITY) && (
              <PeopleCountIsFrame>
                <OperatorAndNumberFrame>
                  <DropdownSelect
                    label="Operator"
                    width="37.23%"
                    onChange={(e) => setCondition(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option>Greater than</option>
                    <option>Less than</option>
                  </DropdownSelect>
                  <NumberInput
                    type="number"
                    label="Number"
                    width="20%"
                    value={value}
                    onChange={(value) => setValue(value)}
                    error={isError}
                    isError={isError}
                    setIsError={setIsError}
                  />
                </OperatorAndNumberFrame>

                {!isCvAppFromInHouseVersion(cvAppList, cvappid) && <><Checkbox
                  name="default"
                  width="auto"
                  label="Enable cool down period "
                  disabled={false}
                  error={false}
                  onChange={handleCoolDownCheckbox}
                  selected={addCoolDownPeriod}
                ></Checkbox>
                {addCoolDownPeriod && (
                  <InputStepperField
                    label={"Cool down period (min.)"}
                    value={coolPeriodValue}
                    onChange={(value) => setCoolPeriodValue(value)}
                    minValue={1}
                    maxValue={43201} // 30 days in minutes
                    readOnly={false}
                  />
                )}</>}
              </PeopleCountIsFrame>
            )}
            {
              showCoolDownCheckBox && 
              <PeopleCountIsFrame>
                {!isCvAppFromInHouseVersion(cvAppList, cvappid) && <><Checkbox
                  name="default"
                  width="auto"
                  label="Enable cool down period "
                  disabled={false}
                  error={false}
                  onChange={handleCoolDownCheckbox}
                  selected={addCoolDownPeriod}
                ></Checkbox> 
                {addCoolDownPeriod && (
                  <InputStepperField
                    label={"Cool down period (sec.)"}
                    unitoftime="seconds"
                    value={coolPeriodValue}
                    onChange={(value) => setCoolPeriodValue(value)}
                    minValue={10}
                    maxValue={43201}
                    readOnly={false}
                  />
                )}</>}
              </PeopleCountIsFrame>
            }
          </TriggerInsideFrame>
        </ConditionContainer>
      </TriggerFrame>
    </>
  );
}

export default Trigger;
